export default {"src":"/_next/static/media/lead-about.9756db14.svg","height":120,"width":519};